import React, { useSyncExternalStore } from 'react';
import { Link } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ShieldCheck } from 'lucide-react';
import { purchaseLimitModalStore } from '@/stores/purchaseLimitModalStore';

export function GlobalPurchaseLimitModal() {
  const state = useSyncExternalStore(
    purchaseLimitModalStore.subscribe,
    () => purchaseLimitModalStore.getState(),
    () => purchaseLimitModalStore.getState()
  );

  const onOpenChange = (open: boolean) => {
    if (!open) purchaseLimitModalStore.close();
  };

  return (
    <Dialog open={state.isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" aria-describedby="purchase-limit-description">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl font-semibold text-foreground">
            <ShieldCheck className="h-5 w-5 text-amber-500" />
            Purchase limit reached
          </DialogTitle>
          <DialogDescription id="purchase-limit-description" className="text-muted-foreground">
            {state.message}
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground mb-4">
          You can update your daily, weekly, or monthly purchase limits in your profile.
        </p>
        <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-between">
          <Button variant="outline" onClick={() => purchaseLimitModalStore.close()} className="w-full sm:w-auto">
            Close
          </Button>
          <Button asChild className="w-full sm:w-auto">
            <Link to="/profile?tab=responsible" onClick={() => purchaseLimitModalStore.close()}>
              Go to Responsible Gaming
            </Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
